// tickets-by-product-chart.tsx — Top ticket product groups, horizontal bar.
import { Chart, CHART_COLORS } from '@vnetwork/ui/charts';
import { Card, CardBody, CardTitle, Skeleton } from '@vnetwork/ui/primitives';
import { EmptyState } from '@vnetwork/ui/data';
import { Alert } from '@vnetwork/ui/feedback';
import type { TicketsByProduct } from '@/api/tickets-statistics';

interface Props {
  data: TicketsByProduct[] | undefined;
  isLoading: boolean;
  isError: boolean;
}

const SERIES = [{ key: 'total', label: 'Tickets', color: CHART_COLORS[3] }]; // purple

export function TicketsByProductChart({ data, isLoading, isError }: Props) {
  const rows = (data ?? [])
    .filter((d) => d.total_tickets > 0)
    .sort((a, b) => b.total_tickets - a.total_tickets)
    .slice(0, 15)
    .map((d) => ({
      label: d.product_group_name || '(no product)',
      total: d.total_tickets,
    }));

  return (
    <Card flat>
      <CardBody>
        <CardTitle style={{ marginBottom: 'var(--vn-space-3)' }}>Tickets by Product Group</CardTitle>
        {isError ? (
          <Alert tone="danger" title="Failed to load product data" />
        ) : isLoading ? (
          <Skeleton style={{ height: 260 }} />
        ) : rows.length === 0 ? (
          <EmptyState title="No data" description="No product ticket data in this date range." />
        ) : (
          <Chart
            type="bar"
            data={rows}
            xKey="label"
            series={SERIES}
            height={260}
            showGrid
            showXAxis
            showYAxis
            valueFormatter={(v) => String(v ?? 0)}
          />
        )}
      </CardBody>
    </Card>
  );
}
